// x-gina-big
// 视频变大，文字切换（跟随页面滚动）
(function () {
  if (document.querySelector('.x-gina-big')) {
    gsap.registerPlugin(ScrollTrigger)
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.x-gina-big',
        start: "top top",
        end: "bottom top",
        scrub: true,
        pin: true,
        // markers: true,
      }
    })
    tl.to(".x-gina-big video", {
      duration: 1.5,
      clipPath: 'inset(0px 0px round 0px)',
      ease: "power1.out",
    })
      .to(".x-gina-big-content.air-2-pro", {
        duration: 1,
        opacity: 0,
        ease: "power1.out",
      }, '<')
      .to(".x-gina-big-content.one-pro", {
        duration: 1.5,
        opacity: 1,
        ease: "power1.out",
      }, '<')
  }
})();

// x-gina-lens 电致变色
// 遮罩透明度变化，文字切换（跟随页面滚动）
(function () {
  if (document.querySelector('.x-gina-lens')) {
    gsap.registerPlugin(ScrollTrigger)
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.x-gina-lens',
        start: "top top",
        end: "bottom top",
        scrub: true, // 滚动同步动画
        pin: true,
        // markers: true,
      }
    })
    tl.to(".x-gina-lens-content .intro", {
      duration: 1,
      xPercent: -150,
      opacity: 0.4,
      ease: "power1.out",
    })
      .to(".x-gina-lens-content .mode_1", {
        duration: 1,
        x: 0,
        opacity: 1,
        ease: "power1.out",
      }, '<')
      .to(".x-gina-lens-bg .mask", {
        duration: 1,
        opacity: 0.5,
        ease: "power1.out",
      })
      .to(".x-gina-lens-content .mode_1", {
        duration: 1,
        opacity: 0,
        ease: "power1.out",
      }, '<')
      .to(".x-gina-lens-content .mode_2", {
        duration: 1,
        opacity: 1,
        ease: "power1.out",
      }, '<')
      .to(".x-gina-lens-bg .mask", {
        duration: 1,
        opacity: 0.2,
        ease: "power1.out",
      })
      .to(".x-gina-lens-content .mode_2", {
        duration: 1,
        opacity: 0,
        ease: "power1.out",
      }, '<')
      .to(".x-gina-lens-content .mode_3", {
        duration: 1,
        opacity: 1,
        ease: "power1.out",
      }, '<')
  }
})();


// x-gina-x1
// 文字切换（跟随页面滚动）
(function () {
  if (document.querySelector('.x-gina-x1') && window.innerWidth > 989) {
    gsap.registerPlugin(ScrollTrigger)
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.x-gina-x1',
        start: "top top",
        end: "bottom top",
        scrub: true,
        pin: true,
        // markers: true,
      }
    })
    tl.to(".x-gina-x1__content", {
      y: -window.innerHeight,
      duration: 1,
      ease: "power2.out"
    })
  }
})();


// x-gina-mic
// 图片hover左右放大
(function () {
  if (document.querySelector('.x-gina-mic') && window.innerWidth > 989) {
    document.addEventListener("DOMContentLoaded", () => {
      const box1 = document.querySelector(".x-gina-mic-box.box1");
      const box2 = document.querySelector(".x-gina-mic-box.box2");
      // Hover on box2
      box2.addEventListener("mouseenter", () => {
        gsap.to(box2, {
          flex: "0 0 63%",
          duration: 0.3,
          ease: "power2.out"
        });
        gsap.to(box1, {
          flex: "0 0 37%",
          duration: 0.3,
          ease: "power2.out"
        });
        gsap.to(".x-gina-mic-box.box2 p", {
          opacity: 1,
          height: 60,
          // delay: 0.3,
          duration: 0.3,
          ease: "power2.out",
        });
        gsap.to(".x-gina-mic-box.box1 p", {
          opacity: 0,
          height: 0,
          duration: 0.3,
          ease: "power2.out",
        });
      });

      box2.addEventListener("mouseleave", () => {
        gsap.to(box2, { flex: "0 0 37%", duration: 0.3, ease: "power2.out" }); // 恢复 box2 初始宽度
        gsap.to(box1, { flex: "0 0 63%", duration: 0.3, ease: "power2.out" }); // 恢复 box1 初始宽度
        gsap.to(".x-gina-mic-box.box2 p", {
          opacity: 0,
          height: 0,
          duration: 0.3,
          ease: "power2.out",
        });
        gsap.to(".x-gina-mic-box.box1 p", {
          opacity: 1,
          height: 60,
          // delay: 0.3,
          duration: 0.3,
          ease: "power2.out",
        });
      });
    });
  }
})();

// x-gina-slogan
// 文字变色
(function () {
  if (document.querySelector('.x-gina-slogan')) {
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
      trigger: '.x-gina-slogan',
      start: "top 20%",
      end: "bottom top",
      // scrub: true, // 滚动同步动画（会让颜色变化不流畅）
      // markers: true,
      onEnter: () => {
        gsap.to(".x-gina-slogan-text", {
          duration: 1,
          css: {
            "-webkit-text-fill-color": "transparent",
            "-webkit-background-clip": "text",
            "background-image": "linear-gradient(90deg, #FEE582 0%, #FFBA4F 100%)"
          }
        });
      },
      onLeaveBack: () => {
        gsap.to(".x-gina-slogan h2", {
          duration: 1,
          css: {
            "-webkit-text-fill-color": "white",
            "-webkit-background-clip": "unset",
            "background-image": "unset",
          }
        });
      },
    });
  }
})();

// x-gina-osd
// 图片缩小字出现（跟随页面滚动）
(function () {
  if (document.querySelector('.x-gina-osd')) {
    gsap.registerPlugin(ScrollTrigger)
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.x-gina-osd',
        start: "top top",
        end: "bottom top",
        scrub: true,
        pin: true,
        pinSpacing: false,
        // markers: true,
      }
    })
    tl.from(".x-gina-osd-main", {
      width: "100%",
      height: "100%",
      borderRadius: 0,
      duration: 1,
    }).from(".x-gina-osd__content", {
      opacity: 0,
      duration: 1,
    }, '<')
  }
})();